module.exports = __webpack_public_path__ + "static/media/bg_tab1.56a8f88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/bg_tab1.png
// module id = 211
// module chunks = 0